import ErrorFrame from './ErrorFrame'

export default ErrorFrame
